//types
export const COLOR_CURRENT_COLOR = 'MESUREMENT/CURRENT/COLOR';
export const COLOR_INIT = 'MESUREMENT/CURRENT/INIT';
export const COLOR_VISIBLE = 'MESUREMENT/CURRENT/VISIBLE';


export const setColor = hex => ({ type: COLOR_CURRENT_COLOR, hex });
export const setColorInit = () => ({ type: COLOR_INIT});
export const setMeasureColorVisible = visible => ({ type: COLOR_VISIBLE, visible });